import http from './httpService';

let apiEndpoint = '/abouts';

export function getAboutData() {
  return http.get(`${apiEndpoint}`);
}

export function updateBoard(formData) {
  return http.put(`${apiEndpoint}/board`, formData);
}